export default "__VITE_ASSET__BGzsoG1Y__"